import { gql } from '@apollo/client';

export const GET_CYBER_LOCATION_LIST = gql`
  query GetCyberLocationList {
    getCyberLocationList {
      applictionsMapped
      lastUpdated
      locationName
      isDirty
      locationUUID
      lastManuallyUpdatedAt
    }
  }
`;

export const GET_LOCATIONS_CYBER_MODULE = gql`
  query FindAllLocations {
    findAllLocations {
      uuid
      locationName
      locationType
      cyberSelected
      hasDependencies
    }
  }
`;

export const SET_LOCATIONS_CYBER_MODULE = gql`
  mutation SetSelectLocationsCyberModule($data: [ID!]!) {
    setSelectLocationsCyberModule(data: $data)
  }
`;

export const GET_LOCATION_BUSINESS_FUNCTIONS_DASHBOARD = gql`
  query GetLocationBusinessFunctionsDashboard($data: String!) {
    getLocationBusinessFunctionsDashboard(data: $data) {
      applicationsTagged
      lastUpdated
      isDirty
      name
      supportedByITApplication
      uuid
    }
  }
`;

export const GET_BUSINESS_FUNCTIONS_BY_LOCATION = gql`
  query GetBusinessFunctionsByLocation($data: String!) {
    getBusinessFunctionsByLocation(data: $data) {
      description
      name
      selected
      uuid
    }
  }
`;

export const UPDATE_SELECTED_LOCATION_BUSINESS_FUNCTIONS = gql`
  mutation SetBusinessFunctionSelected(
    $data: SetSelectedLocationBusinessFunctionsInput!
  ) {
    setBusinessFunctionSelected(data: $data)
  }
`;

// Mutation to select IT applications for a location
export const UPDATE_LOCATION_SELECTED_IT_APPS = gql`
  mutation SetLocationItApplicationsToBusinesFunctions(
    $data: LocationItApplicationsMappingInput!
  ) {
    setLocationItApplicationsTobusinesFunctions(data: $data)
  }
`;

export const GET_LOCATION_IT_APPLICATION_DASHBOARD = gql`
  query GetItApplicationsDashboard($locationUUID: ID) {
    getItApplicationsDashboard(locationUUID: $locationUUID) {
      cards {
        applicationsMapped {
          count
          isEnabled
        }
        businessFunctionsMapped {
          count
          isEnabled
        }
        processAreaMapped {
          count
          isEnabled
        }
        qualitativeFactorsMapped {
          count
          isEnabled
        }
      }
      applications {
        businessFunctions
        name
        processes
        processAreas
        qualitativeFactors {
          compliance
          count
          employees
          lifeSafety
          reputation
        }
        revenue
        uuid
        tier {
          color
          name
        }
      }
    }
  }
`;

export const MARK_LOCATION_AS_UPDATED = gql`
  mutation MarkLocationAsUpdated($data: MarkLocationAsUpdatedInput!) {
    markLocationAsUpdated(data: $data) {
      uuid
      locationName
      lastManuallyUpdatedAt
    }
  }
`;
